module.exports = __webpack_public_path__ + "static/media/HCMM416.be716290.jpg";